<template>
    <b-modal
        v-if="$can('create', 'people')"
        id="create-people-modal"
        v-model="active"
        centered
        hideFooter
        :title="$t('modules.people.new')"
        @show="setAttributesDefaultValues"
    >
        <div>
            <div class="ml-2 mr-2 mt-1">
                <formulateForm
                    v-slot="{ hasErrors }"
                    v-model="formData"
                    name="peopleForm"
                >
                    <b-row>
                        <b-col cols="12">
                            <formulateInput
                                v-if="originsOptions"
                                :label="$t('common.crud.recommendation')"
                                name="origin"
                                :placeholder="$t('common.crud.recommendation')"
                                type="select"
                                validation="optional|max:32,length"
                                :options="
                                    originsOptions.map((el) => ({
                                        value: el.id,
                                        label: el.description,
                                    }))
                                "
                            />
                        </b-col>

                        <b-col cols="12" class="mt-2 mb-2">
                            <vue-autosuggest
                                id="name"
                                v-model="formData.name"
                                :suggestions="peopleOptions"
                                :limit="15"
                                :inputProps="{
                                    id: 'autosuggest__input',
                                    class: 'form-control',
                                    placeholder: $t('common.crud.name'),
                                }"
                                @input="onSearchPeopleByName"
                                @selected="setResult"
                            >
                                <template slot="before-input">
                                    <label for="name">{{
                                        $t("common.crud.name")
                                    }}</label>
                                </template>

                                <template slot-scope="{ suggestion }">
                                    <span class="my-suggestion-item">{{
                                        suggestion.item.name
                                    }}</span>
                                </template>
                            </vue-autosuggest>
                        </b-col>

                        <b-col v-if="createdPerson" cols="12">
                            <contact-card
                                resourceType="people"
                                :resourceData="createdPerson"
                                style="box-shadow: none"
                                :phoneClassificationsOptions="
                                    phoneClassificationsOptions
                                "
                                :noHeader="true"
                                phoneModalId="create:person:add-phone"
                                emailModalId="create:person:add-email"
                                @deletePhone="
                                    createdPerson.phones = createdPerson.phones.filter(
                                        (el) => el.id !== $event.id
                                    )
                                "
                                @attachPhone="attachPhone($event)"
                                @deleteEmail="
                                    createdPerson.emails = createdPerson.emails.filter(
                                        (el) => el.id !== $event.id
                                    )
                                "
                                @attachEmail="attachEmail($event)"
                            >
                            </contact-card>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col class="d-flex justify-content-center">
                            <formulateErrors />
                        </b-col>
                    </b-row>

                    <b-row class="mt-3">
                        <b-col
                            v-if="!createdPerson"
                            class="d-flex justify-content-center"
                        >
                            <formulateInput
                                :disabled="hasErrors || isLoading"
                                :label="
                                    isLoading
                                        ? $t('common.crud.creating')
                                        : $t('common.crud.create')
                                "
                                inputClass="btn btn-primary"
                                type="submit"
                                @click="handleSubmit"
                            />
                        </b-col>

                        <b-col
                            v-if="createdPerson"
                            class="d-flex justify-content-center"
                        >
                            <formulateInput
                                :disabled="hasErrors || isLoading"
                                :label="$t('common.crud.edit')"
                                inputClass="btn btn-primary"
                                type="button"
                                @click="changeRoute(createdPerson.id)"
                            />
                        </b-col>

                        <b-col class="d-flex justify-content-center">
                            <FormulateInput
                                :label="$t('common.crud.close')"
                                inputClass="btn btn-danger"
                                type="button"
                                @click="hide"
                            />
                        </b-col>
                    </b-row>
                </formulateForm>
            </div>
        </div>
    </b-modal>
</template>

<script>
import { BRow, BCol, BModal } from "bootstrap-vue"
import { VueAutosuggest } from "vue-autosuggest"
import Api from "@/services/api/index"
import _ from "lodash"
import ContactCard from "@/views/components/utilis-spa/contacts/ContactCard.vue"
import toastMessages from "@/views/components/utilis-spa/utilities/ToastMessages"

export default {
    name: "PeopleCreateModal",
    components: {
        BRow,
        BCol,
        BModal,
        VueAutosuggest,
        ContactCard,
    },
    data() {
        return {
            active: false,
            formData: {
                origin: "",
                name: "",
            },
            isLoading: false,
            originsOptions: [],
            phoneClassificationsOptions: [],
            peopleOptions: [],
            selected: "",
            loadForms: false,
            createdPerson: null,
        }
    },
    computed: {},
    async created() {
        const addEmailForm = document.getElementById("add-email")
        const addPhoneForm = document.getElementById("add-phone")

        if (!addEmailForm && !addPhoneForm) this.loadForms = true

        const systemRecords = await Promise.all([
            this.getOrigins(),
            this.getPhoneClassificationsOptions(),
        ])

        this.$eventHub.$on("showCreatePeopleModal", this.show)
        this.$eventHub.$on("hideCreatePeopleModal", this.hide)

        this.originsOptions = systemRecords[0].data
        this.phoneClassificationsOptions = systemRecords[1].data
    },
    methods: {
        attachPhone(phone) {
            const newCreatedPerson = _.cloneDeep(this.createdPerson)
            newCreatedPerson.phones = [...newCreatedPerson.phones, ...[phone]]

            this.createdPerson = newCreatedPerson
        },
        attachEmail(email) {
            const newCreatedPerson = _.cloneDeep(this.createdPerson)
            newCreatedPerson.emails = [...newCreatedPerson.emails, ...[email]]

            this.createdPerson = newCreatedPerson
        },
        showControls(index, resource) {
            this.selected = { index, resource }
        },
        hideControls() {
            this.selected = ""
        },
        show() {
            this.active = true
        },
        hide() {
            this.active = false
            this.setAttributesDefaultValues()
        },
        onSearchPeopleByName(text) {
            if (text) {
                this.search(text, this)
            }
        },
        search: _.debounce(async (search, vm) => {
            const people = await Api.findAll("people", {
                filter: {
                    search,
                },
            })

            // eslint-disable-next-line no-param-reassign
            vm.peopleOptions = [
                {
                    data: people.data,
                },
            ]
        }, 350),

        setResult(selected) {
            if (selected) {
                this.changeRoute(selected.item.id)
            }
        },
        changeRoute(value) {
            this.hide()
            this.$router.push({
                name: "view-people",
                params: { id: value },
            })
        },

        getOrigins() {
            return Api.findAll("origin", {
                fields: { origin: "description" },
            })
        },

        getPhoneClassificationsOptions() {
            return Api.findAll("phone-classifications", {
                fields: { "phone-classifications": "description" },
            })
        },

        setAttributesDefaultValues() {
            this.formData.name = ""
            this.formData.origin = ""
            this.createdPerson = null
        },

        async handleSubmit() {
            try {
                this.isLoading = true
                const response = await Api.create("people", {
                    name: this.formData.name,
                })
                this.createdPerson = response.data

                if (this.formData.origin) {
                    await Api.one("people", this.createdPerson.id)
                        .relationships("origin")
                        .patch({
                            type: "origins",
                            id: this.formData.origin,
                        })
                }
                this.$toast(toastMessages.getSuccessMessage())
            } catch (e) {
                this.$formulate.handle(e, "peopleForm")
                this.createdPerson = null
                this.$toast(toastMessages.getUnexpectedError())
            } finally {
                this.isLoading = false
            }
        },
    },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-autosuggest.scss";

.autocomplete .form-group {
    margin-bottom: 0;
}

.add-related-resource {
    text-decoration: underline;
    text-decoration-color: #519bd6;
    color: #519bd6;
    display: block;
}

.add-related-resource:hover {
    cursor: pointer;
}

.header-sidebar {
    background-color: #f8f8f8;
    color: #5e5873;
}

.table {
    border: none;
}

.autocomplete {
    position: relative;
}

.autocomplete-results {
    padding: 0;
    margin: 0;
    border: 1px solid #eeeeee;
    height: 10rem;
    overflow: auto;
}

.autocomplete-result {
    list-style: none;
    text-align: left;
    padding: 4px 2px;
    cursor: pointer;
}

.autocomplete-result.is-active,
.autocomplete-result:hover {
    background-color: #4aae9b;
    color: white;
}
</style>
